import Layout from "../layout/Layout.tsx";
import React, {useEffect, useState} from "react";
import {
    Button,
    Card,
    CardBody,
    CardImg,
    CardText, Form, FormCheck,
    Image,
    ToggleButton,
    ToggleButtonGroup
} from "react-bootstrap";
import {url} from "../utils/UrlsUtil.ts";
import "../../style/mydesign/my_design_card_page.scss";
import {isEmpty, isNotEmpty} from "../utils/CommonUtil.ts";
import {
    CARD_DESIGN_MYSELF_FORMAT,
    CARD_DESIGN_REQUEST_FORMAT, CARD_DESIGN_UPLOAD_FORMAT, isCardDesignMyselfFormat,
    isCardDesignRequestFormat, isCardDesignUploadFormat
} from "../const/FormatGroupIdConst.ts";
import {post, postUpload} from "../utils/FetchUtil.ts";
import {useLoading} from "../components/loading/LoadingProvider.tsx";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import {img} from "../utils/ImageUtil.ts";
import {
    isMyDesignDetailColor,
    isMyDesignDetailImageCropper,
    isMyDesignDetailImages,
    isMyDesignDetailInputs
} from "../const/MyDesignDetailTypeConst.ts";
import MyDesignDetailInput from "../components/input/MyDesignDetailInput.tsx";
import MyDesignImageFile from "../components/image/MyDesignImageFile.tsx";
import {concatMessage, popErrors} from "../utils/MessageUtil.ts";
import MyDesignColor from "../components/color/MyDesignColor.tsx";
import MyDesignImageCropper from "../components/image/MyDesignImageCropper.tsx";
import MyDesignCardPreview from "../components/image/MyDesignCardPreview.tsx";
import {useLocation, useNavigate} from "react-router-dom";

interface MyDesignCardForm{
    format_group_id: string;
    event_category_code: string;
    design_template_code?: string;
    design_goods_code?: string;
    allocate_order_number?: string | null;
    allocate_order_detailnumber?: number;
    guide_image_path?: string;
}

const MyDesignCardPage: React.FC = () => {
    const location = useLocation();
    const fromPage = location.state?.from;
    const query = new URLSearchParams(location.search);
    useEffect(() => {
        const encodedOrderParams = query.get("ord");
        let orderNumber: string;
        let orderDetailNumber: number = 0;
        if(encodedOrderParams){
            const decodeParams = decodeURIComponent(encodedOrderParams);
            if(isNotEmpty(decodeParams)){
                const arrOrderInfo = decodeParams.split(";");
                if(arrOrderInfo && arrOrderInfo.length == 2){
                    orderNumber = arrOrderInfo[0];
                    orderDetailNumber = parseInt(arrOrderInfo[1]);
                }
            }
        }
        setMyDesignCardForm(prevState => ({
            ...prevState,
            allocate_order_number: orderNumber,
            allocate_order_detailnumber: orderDetailNumber
        }));
    }, []);
    const navigate = useNavigate();
    const { showLoading, hideLoading } = useLoading();
    const [errorList, setErrorList] = useState([]);
    const [myDesignCardForm, setMyDesignCardForm] = useState<MyDesignCardForm>({
        format_group_id: "",
        event_category_code: "",
        design_template_code: "",
        design_goods_code: "",
        allocate_order_number: "",
        allocate_order_detailnumber: 0,
        guide_image_path: ""
    });
    const [eventCategoryList, setEventCategoryList] = useState<EventCategoryDto[] | null | undefined>([]);
    const [templateList, setTemplateList] = useState<DesignTemplateDto[] | null | undefined>([]);
    const [templateDetailList, setTemplateDetailList] = useState<DesignTemplateDetailDto[]>([]);
    const onChangeDesignMethod = (val: string) => {
        setMyDesignCardForm(prevState => ({
            ...prevState, format_group_id: val,
            event_category_code: "",
            design_template_code: "",
            design_goods_code: "",
            guide_image_path: ""
        }));
        setEventCategoryList([]);
        setTemplateList([]);
        clearMyDesignInput();
        setErrorList([]);
        if(!isCardDesignUploadFormat(val)){
            getCardEventCategories(val);
        }
    };
    const getCardEventCategories = (format_group_id: string) => {
        showLoading();
        post<EventCategoryDto[]>({
            action: "/api/mydesign/card/event_categories",
            data: {format_group_id: format_group_id}
        })
            .then((data) => {
                if(data && data?.length > 1) {
                    setEventCategoryList(data);
                    getCardDesignTemplates(format_group_id, myDesignCardForm.event_category_code);
                }else {
                    if (data?.length === 1) {
                        getCardDesignTemplates(format_group_id, data[0].code);
                    }
                }
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const onChangeEventCategory = (val: string) => {
        setMyDesignCardForm(prevState => ({
            ...prevState, event_category_code: val,
            design_template_code: "",
            design_goods_code: "",
            guide_image_path: ""
        }));
        clearMyDesignInput();
        if(!isCardDesignUploadFormat(myDesignCardForm.format_group_id)){
            getCardDesignTemplates(myDesignCardForm.format_group_id, val);
        }
    };
    const getCardDesignTemplates = (format_group_id: string, event_category_code: string) => {
        showLoading();
        post<DesignTemplateDto[]>({
            action: "/api/mydesign/templates",
            data: {format_group_id: format_group_id, event_category_code: event_category_code}
        })
            .then((data) => {
                setTemplateList(data);
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const onChangeTemplate = (dto: DesignTemplateDto) => {
        setMyDesignCardForm(prevState => ({
            ...prevState,
            design_template_code: dto.design_template_code,
            design_goods_code: dto.format_goods_code,
            guide_image_path: dto.goods_image_path02
        }));
        if(myDesignCardForm.design_template_code !== dto.design_template_code){
            clearMyDesignInput();
            getTemplateDetails(dto.design_template_code);
        }else{
            if(isCardDesignMyselfFormat(myDesignCardForm.format_group_id)){
                if(autoPreview && croppedImage){
                    createCardPreview(croppedImage, dto.format_goods_code);
                }
            }
        }
    };
    const getTemplateDetails = (template_code?: string) => {
        showLoading();
        post<DesignTemplateDetailDto[]>({
            action: "/api/mydesign/template/details",
            data: {design_template_code: template_code}
        })
            .then((data) => {
                if(data && data?.length > 0) {
                    setTemplateDetailList(data);
                }
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const onClickSave = () => {
        let err =  "";
        if(isCardDesignRequestFormat(myDesignCardForm.format_group_id)){
            if(isEmpty(myDesignCardForm.design_goods_code)){
                err = "カードデザインをお選びください。";
            }else{
                // @ts-ignore
                templateDetailList.forEach((item) => {
                    if(item.required){
                        if(isMyDesignDetailInputs(item.type) && isEmpty(item.content)){
                            err = concatMessage("「" + item.title + "」の入力は必須です。", err);
                        }else if(isMyDesignDetailImages(item.type) && !item.file){
                            err = concatMessage("「" + item.title + "」ファイルをご選択ください。", err);
                        }
                    }
                });
            }
        }else {
            if(isEmpty(previewUrl)){
                err = "カードデザイン用写真やテキストを入力した後、プレビューをご確認ください。";
            }
        }
        if(isNotEmpty(err)){
            popErrors(err);
        }else {
            entryMyDesign();
        }
    };
    const clearMyDesignInput = () => {
        setTemplateDetailList([]);
        setCroppedImage(null);
        setPreviewUrl(undefined);
    }
    const [autoPreview, setAutoPreview] = useState<boolean>(true);
    const [previewUrl, setPreviewUrl] = useState<string | undefined>(undefined);
    const [croppedImage, setCroppedImage] = useState<File | null>(null);
    const handleCropImage = (file: File | null) => {
        setCroppedImage(file);
        if(autoPreview){
            if (file) {
                createCardPreview(file);
            } else {
                setPreviewUrl(undefined);
            }
        }
    };
    const [myDesignUploadDto, setMyDesignUploadDto] = useState<DesignTemplateDetailDto | undefined>({
        detail_number: 0,
        type: "002",
        field_name: "bg_image",
        title: "写真をアップロードしてください。"
    });
    const createCardPreview = (file: File, designGoodsCode: string | undefined = undefined) => {
        showLoading();
        const formData = new FormData();
        // @ts-ignore
        formData.append('file', file);
        formData.append('design_template_json', buildMyDesignJson(designGoodsCode));
        postUpload<DesignTemplateDto>({
            action: "/api/mydesign/card/preview",
            data: formData,
        })
            .then((data) => {
                if(isNotEmpty(data?.error_message)){
                    // @ts-ignore
                    setErrorList([data.error_message])
                }else{
                    setPreviewUrl(data?.preview_image_path);
                    if(templateDetailList && templateDetailList.length !== 0){
                        templateDetailList.forEach((item) => {
                            if (isMyDesignDetailImages(item.type)) {
                                item.content = data?.upload_image_path;
                            }
                        });
                    }else{
                        setMyDesignUploadDto(prevState => ({ ...prevState, content: data?.upload_image_path}));
                    }
                }
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const buildMyDesignJson = (designGoodsCode: string | undefined = undefined): string => {
        if(isCardDesignUploadFormat(myDesignCardForm.format_group_id)){
            designGoodsCode = "GCO-ULD-08T00";
        }else{
            if(isEmpty(designGoodsCode)){
                designGoodsCode = myDesignCardForm.design_goods_code;
            }
        }
        let designTemplateDto: DesignTemplateDto = {
            format_group_id: myDesignCardForm.format_group_id,
            format_goods_code: designGoodsCode,
            design_template_code: myDesignCardForm.design_template_code,
            preview_image_path: previewUrl,
            allocate_order_number: myDesignCardForm.allocate_order_number,
            allocate_order_detailnumber: myDesignCardForm.allocate_order_detailnumber
        }
        if(isCardDesignUploadFormat(myDesignCardForm.format_group_id)){
            if(myDesignUploadDto){
                designTemplateDto.details = [myDesignUploadDto];
            }
        }else{
            if(templateDetailList && templateDetailList.length != 0){
                designTemplateDto.details = templateDetailList;
            }

        }
        return JSON.stringify(designTemplateDto);
    };
    const handlePreview = () => {
        if(croppedImage == null){
            popErrors("カードデザイン用写真をアップロードしてください。");
        }else {
            createCardPreview(croppedImage);
        }
    };
    const onChangeAutoPreview = (checked: boolean) => {
        setAutoPreview(checked);
        if(checked){
            if (croppedImage) {
                createCardPreview(croppedImage);
            } else {
                setPreviewUrl(undefined);
            }
        }
    }
    const handleSubmitInput = () => {
        if(isCardDesignMyselfFormat(myDesignCardForm.format_group_id)){
            if(autoPreview && croppedImage){
                createCardPreview(croppedImage);
            }
        }
        return false;
    }
    const handleInputContent = (detailNumber: number | undefined, value: string) => {
        setTemplateDetailList(prevList =>
            prevList.map(item =>
                item.detail_number === detailNumber
                    ? { ...item, content: value }
                    : item
            )
        );
    }
    const entryMyDesign = () => {
        showLoading();
        const formData = new FormData();
        if(isCardDesignRequestFormat(myDesignCardForm.format_group_id)){
            // @ts-ignore
            templateDetailList.forEach((item) => {
                if (item.file) {
                    formData.append(`file_${item.detail_number}`, item.file);
                }
            });
        }
        formData.append('design_template_json', buildMyDesignJson());
        postUpload<DesignTemplateDto>({
            action: "/api/mydesign/card/entry",
            data: formData,
        })
            .then((data) => {
                if(isNotEmpty(data?.error_message)){
                    // @ts-ignore
                    setErrorList([data.error_message])
                }else{
                    onClickBack();
                }
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const onClickBack = () => {
        if (fromPage){
            navigate(fromPage);
        }else {
            navigate('/template');
        }
    }
    return <Layout page_meta = {{title: 'マイデザインの製作｜ギフトアレンジ'}}
                   breadcrumb_list={["マイデザインの製作", "オリジナルカード"]}
                   error_list = {errorList}
    >
        <article className="mb-5" id="myDesignCardTempPage">
            <h2 className={"page-content-title"}>
                オリジナルギフトカード（有料 ：１回の印刷に付き2,750円）<br/>
                <span>※複数枚や、複数場所への出荷の場合でも印刷工程が１度の場合は価格内でご対応します。</span>
            </h2>
            <br/>
            <section className={"design-methods"}>
                {isEmpty(myDesignCardForm.format_group_id) && (
                    <p className={"design-method-msg text-danger"}>
                        3つ製作方法からお選びください。
                    </p>
                )}
                <ToggleButtonGroup name={"design_methods"} type={"radio"} defaultValue={""} onChange={onChangeDesignMethod}>
                    <ToggleButton id={"tbRequestDesign"}
                                  name={"design_method"}
                                  variant={"light"}
                                  value={CARD_DESIGN_REQUEST_FORMAT}
                                  className={`design-method-btn ${isCardDesignRequestFormat(myDesignCardForm.format_group_id) ? "active" : ""}`}
                    >
                        <Image src={url('/images/icon/request_design_icon.png')}/>
                        <p>テンプレから<br/>デザイン依頼</p>
                    </ToggleButton>
                    <ToggleButton id={"tbDesignMyself"}
                                  name={"design_method"}
                                  variant={"light"}
                                  value={CARD_DESIGN_MYSELF_FORMAT}
                                  className={`design-method-btn ${isCardDesignMyselfFormat(myDesignCardForm.format_group_id) ? "active" : ""}`}
                    >
                        <Image src={url('/images/icon/design_myself_icon.png')}/>
                        <p>テンプレから<br/>自分でデザイン</p>
                    </ToggleButton>
                    <ToggleButton id={"tbDesignUpload"}
                                  name={"design_method"}
                                  variant={"light"}
                                  value={CARD_DESIGN_UPLOAD_FORMAT}
                                  className={`design-method-btn ${isCardDesignUploadFormat(myDesignCardForm.format_group_id) ? "active" : ""}`}
                    >
                        <Image src={url('/images/icon/my_design_upload_icon.png')}/>
                        <p>自分で作った<br/>デザインをアップ</p>
                    </ToggleButton>
                </ToggleButtonGroup>
            </section>
            <br/>
            <section className="design-templates">
                <p className="design-description">
                    {isCardDesignRequestFormat(myDesignCardForm.format_group_id) && <>
                        お好きな写真やイラストを用いて、デザイン制作依頼ができます。<br/>
                        ギフトカードの仕上がり寸法は<strong style={{color: '#0E95A4'}}>86mm×54mm</strong>です。<br/>
                        ※<strong className="text-danger">cloche</strong>の場合、カードの<strong className="text-danger">角丸加工は行いません。</strong><br/>
                        ※「<strong className="text-danger">入力完了</strong>」をすると割り当てるマイデザインは<strong className="text-danger">校正依頼</strong>になります。<br/>
                        ※入力完了後、<strong className="text-danger">翌２営業日</strong>以内に<strong className="text-danger">校正メール</strong>をお送りしますので、必ずご確認ください。
                    </>}
                    {isCardDesignMyselfFormat(myDesignCardForm.format_group_id) && <>
                        お好きな写真やイラストを用いて、オリジナルデザインに変更できます。<br/>
                        ギフトカードの仕上がり寸法は<strong style={{color: "#0E95A4"}}>86mm×54mm</strong>です。<br/>
                        ※「<strong className="text-danger">入力完了</strong>」をすると割り当てるマイデザインは<strong className="text-danger">そのままで印刷いたします。</strong>
                    </>}
                </p>
                {isCardDesignUploadFormat(myDesignCardForm.format_group_id) && <div className="my-design-upload-description">
                    <p className={"design-description"}>
                        ギフトカードの仕上がり寸法は<strong style={{color: '#0E95A4'}}>86mm×54mm</strong>です。<br/>
                        ※断裁面は印字ができずにフチが残るため、印字したいサイズより、<br className="pc"/><strong style={{color: '#0E95A4', textDecoration: 'underline'}}>５㎜以上の塗り足し<span style={{color: '#080808'}}>（上下縦横が大きめ）</span></strong>のデータが必要になります。<br />
                        ※データの解像度は<strong style={{color: '#0E95A4'}}>1,920px×1,280px</strong>以上のデータを作成してください。<br/>
                        ※データ不備がある場合は、印刷工程へ進むことができません。<br/>
                        ※データの再入稿もしくはご指示のご連絡が必要となり、受付日が延びる場合がございます。<br/>
                        <span className="text-danger">※プレビュー内容がそのまま印刷されます。</span>
                    </p>
                    <div className="text-center">
                        <Image src={url('/images/common/original_card_measurement.png')} fluid={true} />
                    </div>
                </div>}
                {eventCategoryList && eventCategoryList?.length > 1 && <div className="event-category-area">
                    <Swiper className="event-category-swiper"
                            modules={[Navigation]}
                            slidesPerView={4}
                            spaceBetween={0}
                            navigation={{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'}}
                    >
                        <SwiperSlide key="cat_swiper_slide_all">
                            <Card className={`cat-slide-card ${isEmpty(myDesignCardForm.event_category_code) ? "active" : ""}`}
                                  onClick={() => onChangeEventCategory("")}
                            >
                                <CardBody>
                                    <div className="category-icon-area">
                                        <Image src={url('/images/common/all.png')} fluid={true} />
                                    </div>
                                    <CardText>すべて</CardText>
                                </CardBody>
                            </Card>
                        </SwiperSlide>
                        {eventCategoryList?.map((eventDto, index) =>
                            <SwiperSlide key={`cat_swiper_slide${index}`}>
                                <Card className={`cat-slide-card ${eventDto.code === myDesignCardForm.event_category_code ? "active" : ""}`}
                                      onClick={() => onChangeEventCategory(eventDto.code)}
                                >
                                    <CardBody>
                                        <div className="category-icon-area">
                                            <Image src={img(eventDto.icon_path)} fluid={true} />
                                        </div>
                                        <CardText>{eventDto.name}</CardText>
                                    </CardBody>
                                </Card>
                            </SwiperSlide>)}
                    </Swiper>
                </div>}
                {templateList && templateList?.length > 0 && <div className="design-template-list">
                    <Swiper className="design-templates-swiper"
                            modules={[Navigation]}
                            slidesPerView={1.5}
                            spaceBetween={20}
                            navigation={{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'}}
                            breakpoints={{
                                // when window width is >= 640px
                                640: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 20,
                                },
                                // when window width is >= 768px
                                768: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 20,
                                },
                                // when window width is >= 1024px
                                1024: {
                                    slidesPerView: 4.5,
                                    spaceBetween: 20,
                                },
                            }}
                    >
                        {templateList?.map((templateDto, index) =>
                            <SwiperSlide key={`template_swiper_slide${index}`}>
                                <Card className={`border-0 template-slide-card ${myDesignCardForm?.design_goods_code === templateDto.format_goods_code ? "active" : ""}`}>
                                    <CardImg variant={"top"}
                                             src={img(templateDto.format_goods_image_path)}
                                             onClick={() => onChangeTemplate(templateDto)}
                                    />
                                    <CardBody>
                                        <FormCheck type={"radio"}
                                                   id={`rdoDesignGoods_${index}`}
                                                   name={"design-goods"}
                                                   label={templateDto.template_name}
                                                   checked={myDesignCardForm?.design_goods_code === templateDto.format_goods_code}
                                                   onChange={() => onChangeTemplate(templateDto)}
                                        />
                                    </CardBody>
                                </Card>
                            </SwiperSlide>)}
                    </Swiper>
                </div>}
            </section>
            <section>
                <Form className={`card-design-form${isCardDesignUploadFormat(myDesignCardForm.format_group_id)? ' my-design-upload':''}`}>
                    {templateDetailList?.length !== 0 && <div className="text-input-details">
                        {templateDetailList?.filter(dtl => isMyDesignDetailInputs(dtl?.type))
                            .map((templateDetailDto) =>
                                <MyDesignDetailInput key={`my_design_detail_${templateDetailDto.detail_number}`}
                                                     dto={templateDetailDto}
                                                     handleBlur={handleSubmitInput}
                                                     handleChange={(val) => {handleInputContent(templateDetailDto?.detail_number, val)}}
                                />)}
                        <div className="color-input-list">
                            {templateDetailList?.filter(dtl => isMyDesignDetailColor(dtl?.type))
                                .map((templateDetailDto) =>
                                    <MyDesignColor key={`my_design_detail_${templateDetailDto.detail_number}`}
                                                   dto={templateDetailDto}
                                                   handleChange={handleSubmitInput}
                                    />)
                            }
                        </div>
                    </div>}
                    {templateDetailList?.length !== 0 && <div className="image-upload-details">
                        <div className="upload-image-list">
                            {templateDetailList?.filter(dtl => isMyDesignDetailImages(dtl?.type))
                                .map((templateDetailDto) => (
                                    isMyDesignDetailImageCropper(templateDetailDto?.type) ?
                                        <MyDesignImageCropper key={`my_design_detail_${templateDetailDto.detail_number}`} dto={templateDetailDto} handleCrop={handleCropImage} /> :
                                        <MyDesignImageFile key={`my_design_detail_${templateDetailDto.detail_number}`} dto={templateDetailDto}/>
                                ))
                            }
                            {isCardDesignMyselfFormat(myDesignCardForm.format_group_id) && <MyDesignCardPreview imagePath={previewUrl} autoPreview={autoPreview} onChangeAutoPreview={onChangeAutoPreview} handlePreview={handlePreview}></MyDesignCardPreview>}
                        </div>
                        {isCardDesignRequestFormat(myDesignCardForm.format_group_id) && isNotEmpty(myDesignCardForm.guide_image_path) &&
                            <div className="guide-images">
                                <p className={"text-danger"}>※写真の位置は、以下の画像をご参照ください。</p>
                                <Image src={img(myDesignCardForm.guide_image_path)} fluid={true} />
                            </div>
                        }
                    </div>}
                    {isCardDesignUploadFormat(myDesignCardForm.format_group_id) && <>
                        <MyDesignImageCropper dto={myDesignUploadDto} handleCrop={handleCropImage} />
                        <MyDesignCardPreview imagePath={previewUrl} autoPreview={autoPreview} onChangeAutoPreview={onChangeAutoPreview} handlePreview={handlePreview}></MyDesignCardPreview>
                    </>}
                </Form>
            </section>
            <br/><br/>
            <section>
                <div className="buttons-area">
                    <Button variant="light" onClick={onClickBack} >戻る</Button>
                    <Button variant="secondary" onClick={onClickSave} disabled={isEmpty(myDesignCardForm.format_group_id)} >保　存</Button>
                </div>
            </section>
            <br/><br/>
        </article>
    </Layout>;
};
export default MyDesignCardPage;